import { WidgetHandler } from '../../WidgetHandler';
import { callEventFunction } from './callEventFunction';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleWidgetOnLoad(props, value) {
    var _a;
    const handler = new WidgetHandler(props);
    callEventFunction(props, 'onLoad', 'value, handler', value, handler);
    if ((_a = props.config.event) === null || _a === void 0 ? void 0 : _a.onLoadCallOnChange) {
        callEventFunction(props, 'onChange', 'value, handler', value, handler);
    }
}
